import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-906c35ea")

_pushScopeId("data-v-906c35ea")
const _hoisted_1 = { class: "SPhoneNumber__options" }
const _hoisted_2 = { class: "options__search" }
const _hoisted_3 = { class: "options__content" }
const _hoisted_4 = { class: "option__content" }
const _hoisted_5 = { class: "content__name" }
const _hoisted_6 = { class: "content__code" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_maska = _resolveDirective("maska")!

  return (_ctx.state.country_option)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["SPhoneNumber", { invalid: _ctx.isInvalid, disabled: _ctx.disabled }],
        ref: "componentref"
      }, [
        _createVNode("div", {
          class: "SPhoneNumber__country",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleList && _ctx.toggleList(...args)))
        }, [
          _createVNode("img", {
            class: "country__flag",
            src: `/phone/${_ctx.state.country_option.emoji}`,
            alt: "Country Flag"
          }, null, 8, ["src"])
        ]),
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "default-input",
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder,
          value: _ctx.value,
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
        }, null, 40, ["disabled", "placeholder", "value"]), [
          [_directive_maska, { mask: _ctx.state.country_option.mask }]
        ]),
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _withDirectives(_createVNode("input", {
              disabled: _ctx.disabled,
              class: "search__input default-input",
              placeholder: "Поиск",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.search_param = $event))
            }, null, 8, ["disabled"]), [
              [_vModelText, _ctx.state.search_param]
            ])
          ]),
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (phone_option) => {
              return (_openBlock(), _createBlock("div", {
                class: ["options__option", { 'option--active': phone_option.code === _ctx.state.country_option.code }],
                key: phone_option.code,
                onClick: ($event: any) => (_ctx.setCountryOption(phone_option))
              }, [
                _createVNode("img", {
                  class: "option__flag",
                  src: `/phone/${phone_option.emoji}`,
                  alt: "Country Flag"
                }, null, 8, ["src"]),
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, _toDisplayString(phone_option.country), 1),
                  _createVNode("div", _hoisted_6, "+" + _toDisplayString(phone_option.phone_code), 1)
                ])
              ], 10, ["onClick"]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.state.is_list_opened]
        ])
      ], 2))
    : _createCommentVNode("", true)
})